import React, { useMemo } from 'react';
import './NodeInfoWindow.css';
import CopyButton from '../../../CopyButton/CopyButton';
import NodeInfoContext from '../NodeInfoContext/NodeInfoContext';
import normalizeLocaleData from '../../../utils/i18n/normalizeLocaleData';
import en from './locales/NodeInfoWindow.en.json';
import AdditionalIntl from '../../../I18n/AdditionalIntl/AdditionalIntl';
import I18n from '../../../I18n/I18n/I18n';
var messages = normalizeLocaleData(en, '@dm/components.node-info-window');
function NodeRestrictions(_ref) {
  var nodeRestrictions = _ref.nodeRestrictions;
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: messages,
    namespace: "@dm/components.node-info-window"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(I18n, {
    i18n: '@dm/components.node-info-window.restrictions'
  })), /*#__PURE__*/React.createElement("ul", null, Object.keys(nodeRestrictions).flatMap(function (restriction) {
    return nodeRestrictions[restriction].map(function (value) {
      return /*#__PURE__*/React.createElement("li", {
        key: "".concat(restriction, "_").concat(encodeURI(value))
      }, /*#__PURE__*/React.createElement(CopyButton, {
        contentToCopy: restriction
      }, restriction), "==", /*#__PURE__*/React.createElement(CopyButton, {
        contentToCopy: value
      }, value));
    });
  }))));
}
function NodeOptions(_ref2) {
  var optionCategory = _ref2.optionCategory;
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: messages,
    namespace: "@dm/components.node-info-window"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(I18n, {
    i18n: '@dm/components.node-info-window.options'
  }), " (", /*#__PURE__*/React.createElement(CopyButton, {
    contentToCopy: optionCategory.title
  }, optionCategory.title), ")"), /*#__PURE__*/React.createElement("ul", null, optionCategory.values.map(function (value) {
    return /*#__PURE__*/React.createElement("li", {
      key: value
    }, /*#__PURE__*/React.createElement(CopyButton, {
      contentToCopy: value
    }, value));
  }))));
}
function NodeDescriptor(_ref3) {
  var nodeDescriptors = _ref3.nodeDescriptors,
    descriptor = _ref3.descriptor;
  var descriptorValueDisplay = useMemo(function () {
    return nodeDescriptors[descriptor].toString ? nodeDescriptors[descriptor].toString() : nodeDescriptors[descriptor];
  }, [nodeDescriptors, descriptor]);
  return /*#__PURE__*/React.createElement("li", {
    className: "_dm-form__descriptor",
    key: descriptor
  }, /*#__PURE__*/React.createElement(CopyButton, {
    contentToCopy: descriptor
  }, descriptor), "==", /*#__PURE__*/React.createElement(CopyButton, {
    contentToCopy: descriptorValueDisplay
  }, descriptorValueDisplay));
}
function NodeDescriptors(_ref4) {
  var nodeDescriptors = _ref4.nodeDescriptors;
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: messages,
    namespace: "@dm/components.node-info-window"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(I18n, {
    i18n: '@dm/components.node-info-window.descriptors'
  })), /*#__PURE__*/React.createElement("ul", null, Object.keys(nodeDescriptors).map(function (descriptor) {
    return /*#__PURE__*/React.createElement(NodeDescriptor, {
      nodeDescriptors: nodeDescriptors,
      descriptor: descriptor
    });
  }))));
}
function NodeData(_ref5) {
  var nodeDescriptor = _ref5.nodeDescriptor;
  return /*#__PURE__*/React.createElement(React.Fragment, null, nodeDescriptor && nodeDescriptor.restrictions && /*#__PURE__*/React.createElement(NodeRestrictions, {
    nodeRestrictions: nodeDescriptor.restrictions
  }), nodeDescriptor && nodeDescriptor.optionCategory && /*#__PURE__*/React.createElement(NodeOptions, {
    optionCategory: nodeDescriptor.optionCategory
  }), nodeDescriptor && nodeDescriptor.descriptors && /*#__PURE__*/React.createElement(NodeDescriptors, {
    nodeDescriptors: nodeDescriptor.descriptors
  }));
}
export default function NodeInfoWindow() {
  return /*#__PURE__*/React.createElement(NodeInfoContext.Consumer, null, function (_ref6) {
    var label = _ref6.label,
      nodeData = _ref6.nodeData;
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(CopyButton, {
      contentToCopy: label
    }, label), ":", ' ', /*#__PURE__*/React.createElement(CopyButton, {
      contentToCopy: nodeData.code
    }, nodeData.code), /*#__PURE__*/React.createElement(NodeData, {
      nodeDescriptor: nodeData
    }));
  });
}